
import { Item__Atividades } from "../../../../../../../services/atividades/GET";
import { obterListaInsumosLiquidos } from "../../insumosLiquidosPrecisao/meta";
import { obterListaInsumosSolidos } from "../../insumosPrecisao/meta";
import { obterListaInsumosSementes } from "../../insumosSementesPrecisao/meta";

type typeIsumosSeparados = {
    cod_insumo: number | null;
    insumo_nome: string;
    quantidade_planejada: number;
    quantidade_executada: number;
    precisao: number;
    porcentagem: number;
    ordem: number;
};


export function obterPrecisaoGeral(todas_atividades_ativas: Item__Atividades[]): {
    media_solidos: number;
    media_liquidos: number;
    media_sementes: number;
    media_geral: number;
} {

    const insumos_solidos = obterListaInsumosSolidos(todas_atividades_ativas).filter(i => i.quantidade_executada > 0) ?? [];
    const insumos_liquidos = obterListaInsumosLiquidos(todas_atividades_ativas).filter(i => i.quantidade_executada > 0) ?? [];
    const insumos_sementes = obterListaInsumosSementes(todas_atividades_ativas).filter(i => i.quantidade_executada > 0) ?? [];

    const soma_total_solidos = insumos_solidos.reduce((acc, item) => acc + item.precisao, 0);
    const soma_total_liquidos = insumos_liquidos.reduce((acc, item) => acc + item.precisao, 0);
    const soma_total_sementes = insumos_sementes.reduce((acc, item) => acc + item.precisao, 0);

    const media_solidos = soma_total_solidos / insumos_solidos.length;
    const media_liquidos = soma_total_liquidos / insumos_liquidos.length;
    const media_sementes = soma_total_sementes / insumos_sementes.length;

    const media_geral = (media_solidos + media_liquidos + media_sementes) / 3;

    return {
        media_solidos: isNaN(media_solidos) ? 0 : media_solidos,
        media_liquidos: isNaN(media_liquidos) ? 0 : media_liquidos,
        media_sementes: isNaN(media_sementes) ? 0 : media_sementes,
        media_geral: isNaN(media_geral) ? 0 : media_geral
    };
}